<template>
  <div>
    <draggable class="upload-draggable" v-model="images" draggable=".preview-image">
      <template v-if="images.length > 0">
        <div :key="item.key" class="preview-box" v-for="item in images" :style="{ width: widthReal + 'px' }">
          <img class="preview" :src="item.preview" :style="{ height: heightReal + 'px', width: widthReal + 'px' }" />
          <div class="preview-footer">
            <div class="name v-ellipsis">{{ item.name }}</div>
            <i @click.stop="openWindow(item.key_preview)" class="operate-btn el-icon-zoom-in"></i>
            <i @click.stop="deleteImage" class="operate-btn el-icon-delete"></i>
          </div>
        </div>
      </template>
      <div v-if="images.length < max || !max" @click="chooseImage" class="upload-btn v-col v-center" :style="{ height: heightReal + 'px', width: widthReal + 'px' }">
        <i class="icon el-icon-plus"></i>
      </div>
    </draggable>

    <upload-vr-dialog v-if="isShowUploadDialog" :show.sync="isShowUploadDialog" :select_ids="select_ids" @change="handleChange"></upload-vr-dialog>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import uploadVrDialog from './components/upload-vr-dialog';

export default {
  props: ['width', 'height', 'max'],

  components: { draggable, uploadVrDialog },

  data() {
    return {
      isShowUploadDialog: false,
      images: [],
      select_ids: [], //已选资源库内ids
    };
  },

  computed: {
    widthReal() {
      return this.width > 300 ? 300 : this.width;
    },

    heightReal() {
      return this.width > 300 ? this.height / (this.width / 300) : this.height;
    },
  },

  methods: {
    //选择商品图片
    chooseImage() {
      this.isShowUploadDialog = true;
    },

    handleChange(images_lib, image_upload) {
      images_lib.forEach((item) => {
        item.preview = item.thumb_preview;
      });
      this.images = this.images.concat(images_lib, image_upload);
      this.select_ids = this.images.filter((item) => !!item.id).map((item) => item.id);
      this.$emit('change', this.images);
    },

    //删除图片
    deleteImage(index) {
      this.images.splice(index, 1);
      this.select_ids = this.images.filter((item) => !!item.id).map((item) => item.id);
      this.$emit('change', this.images);
    },

    openWindow(url) {
      window.open(url, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-draggable {
  display: flex;
  flex-wrap: wrap;
}

.upload-btn {
  border: 1px dashed #9a9a9a;
  border-radius: 4px;
  cursor: pointer;
  color: #9a9a9a;
  justify-content: center;
  box-sizing: border-box;
  margin: 0 10px 0 0;

  .icon {
    font-size: 22px;
  }

  .txt {
    font-size: 12px;
  }
}

.preview-box {
  position: relative;
  line-height: 1;
  margin: 0 10px 10px 0;

  .preview {
    display: block;
  }

  .preview-footer {
    display: flex;
    font-size: 12px;
    height: 25px;
    line-height: 25px;
    background: rgba(0, 0, 0, 0.3);
    color: #fff;
    align-items: center;
    transition: all 0.3s ease;
  }

  .preview-footer .name {
    flex: 1;
    font-size: 12px;
    padding: 0 10px;
    height: 25px;
  }

  .preview-footer .operate-btn {
    color: #fff;
    margin-right: 10px;
    cursor: pointer;
    line-height: 25px;
  }
}
</style>
